// extracted by mini-css-extract-plugin
export default {"ButtonAddTransactions":"ButtonAddTransactions_ButtonAddTransactions__tszSZ","AddIcon":"ButtonAddTransactions_AddIcon__OqpTc"};